(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["business-card-service"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-card-service]').forEach((root) => {
    const form = root.querySelector('.service-form')
    if (!form) return
    const steps = [...form.querySelectorAll('[data-service-step]')]
    const progress = [...form.querySelectorAll('[data-service-progress]')]
    const alert = form.querySelector('[data-service-alert]')
    const showStep = (number) => {
      steps.forEach((step) => step.classList.toggle('is-active', step.dataset.serviceStep === String(number)))
      progress.forEach((item) => {
        const active = Number(item.dataset.serviceProgress) <= number
        item.disabled = !active
        item.classList.toggle('is-active', item.dataset.serviceProgress === String(number))
      })
      form.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    const selected = (name) => form.querySelector(`[name="${name}"]:checked`)
    const options = () => [...form.querySelectorAll('.service-options input:checked')].map((input) => input.value)
    const updateSummary = () => {
      const need = selected('service-need')
      const pack = selected('service-package')
      const needTarget = form.querySelector('[data-service-summary-need]')
      const packageTarget = form.querySelector('[data-service-summary-package]')
      const optionsTarget = form.querySelector('[data-service-summary-options]')
      if (needTarget) needTarget.textContent = need ? need.value : ''
      if (packageTarget) packageTarget.textContent = pack ? pack.value : ''
      if (optionsTarget) optionsTarget.textContent = options().join(' · ')
    }
    form.addEventListener('change', (event) => {
      if (event.target.name === 'service-package') {
        const price = form.querySelector('[data-service-price]')
        price.hidden = false
        price.querySelector('[data-service-price-value]').textContent = event.target.dataset.price
      }
      updateSummary()
    })
    form.querySelectorAll('[data-service-next]').forEach((button) => button.addEventListener('click', () => {
      const target = Number(button.dataset.serviceNext)
      if (target === 3 && !selected('service-package')) {
        alert.hidden = false
        alert.textContent = 'Bitte wähle zuerst einen passenden Umfang.'
        return
      }
      alert.hidden = true
      updateSummary()
      showStep(target)
    }))
    form.querySelectorAll('[data-service-back]').forEach((button) => button.addEventListener('click', () => showStep(Number(button.dataset.serviceBack))))
    progress.forEach((button) => button.addEventListener('click', () => {
      if (!button.disabled) showStep(Number(button.dataset.serviceProgress))
    }))
    form.addEventListener('submit', (event) => {
      const pack = selected('service-package')
      const date = form.querySelector('[data-service-date]')
      const time = form.querySelector('[data-service-time]')
      const privacy = form.querySelector('[data-service-privacy]')
      if (!pack || !date.value || !time.value || !privacy.checked || !form.checkValidity()) {
        event.preventDefault()
        alert.hidden = false
        alert.textContent = 'Bitte fülle alle Pflichtfelder aus und bestätige den Datenschutz.'
        form.reportValidity()
        return
      }
      const lines = [
        `Bedarf: ${selected('service-need').value}`,
        `Gewählter Umfang: ${pack.value}`,
        `Angezeigte Orientierung: ${pack.dataset.price}`,
        `Anlässe: ${options().join(', ')}`,
        `Gewünschter Rückruf: ${date.value}, ${time.value}`,
        `Unternehmen: ${form.querySelector('[data-service-company]').value || 'Nicht angegeben'}`,
        `Ansprechperson: ${form.querySelector('[data-service-name]').value}`,
        `Telefon: ${form.querySelector('[data-service-phone]').value}`,
        `Hinweise: ${form.querySelector('[data-service-note]').value || 'Keine'}`
      ]
      form.querySelector('[data-service-message]').value = lines.join('\n')
    })
    updateSummary()
  })

  } catch(e) { console.error(e); }
})();
})();
